const ArrayView = Backbone.View.extend({
	initialize(opts) {
		this.options = opts;
	},
	render() {
		const data = this.model.get(this.options.modelKey);
		_.each(data, (item, i) => {
			const label = (this.options.labelKey) ? item[this.options.labelKey] : this.options.label;
			const options =  {...this.options,
				modelKey: `${this.options.modelKey}-${this.options.valueKey}-${i}`,
				label: label
			};
			const input = new this.options.view(...options, data);
			this.$el.append(input.render(options));
			if (this.options.readonly === 'readonly') {
				input.renderReadOnly(item[this.options.valueKey]);
			}
		});
		return this.el;
	}
});

export default ArrayView;
